import { DropdownConstants } from '../constants/DropdownConstants';
import Item from '../types/ItemType';
import { formatCapitalizeFirstLetters } from './utils';

export const sortDropdownValues = (items: string[]): string[] => {
    return items.sort((a, b) => {
        if (a === DropdownConstants.ALL) return -1;
        if (b === DropdownConstants.ALL) return 1;
        return a.localeCompare(b);
    });
};

export const formatDropdownValues = (sortedItems: string[]): Item[] => {
    return sortedItems.map((item) => ({
        label: formatCapitalizeFirstLetters(item),
        value: item,
    }));
};

export const sortAndFormatDropdownValues = (items: string[]): Item[] => {
    const sortedItems = sortDropdownValues(items);
    return formatDropdownValues(sortedItems);
};
